import { View, Text, styled, ScrollView } from 'tamagui'
import { useState } from 'react'

const Container = styled(View, { flex: 1, flexDirection: 'column' })

const Header = styled(View, {
  paddingHorizontal: 32, paddingVertical: 20,
  borderBottomWidth: 1, borderBottomColor: '$borderDefault',
})

const Title = styled(Text, {
  fontFamily: '$fontHeading', fontWeight: '600', fontSize: 20, color: '$surfaceForeground',
})

const Body = styled(View, { padding: 32, gap: 24, maxWidth: 600 })

const SectionTitle = styled(Text, {
  fontFamily: '$fontBody', fontWeight: '600', fontSize: 15, color: '$surfaceForeground', marginBottom: 4,
})

const SectionDesc = styled(Text, {
  fontFamily: '$fontBody', fontSize: 13, color: '$sidebarMuted', marginBottom: 12,
})

const OptionRow = styled(View, { gap: 6 })

const RadioItem = styled(View, {
  flexDirection: 'row', alignItems: 'center', height: 36, gap: 10,
  paddingHorizontal: 12, borderRadius: '$borderRadiusMd', cursor: 'pointer',
  hoverStyle: { backgroundColor: '$sidebarHover' },
})

const RadioDot = styled(View, {
  width: 16, height: 16, borderRadius: '$borderRadiusLg', borderWidth: 2, borderColor: '$borderDefault',
  alignItems: 'center', justifyContent: 'center',
  variants: { active: { true: { borderColor: '$accent' } } } as const,
})

const RadioFill = styled(View, {
  width: 8, height: 8, borderRadius: '$borderRadiusSm', backgroundColor: '$accent',
})

const RadioLabel = styled(Text, {
  fontFamily: '$fontBody', fontSize: 14, color: '$surfaceForeground',
})

const verificationLevels = [
  { id: 'none', label: 'None', desc: 'No restrictions' },
  { id: 'low', label: 'Low', desc: 'Must have a verified email' },
  { id: 'medium', label: 'Medium', desc: 'Must be registered for 5+ minutes' },
  { id: 'high', label: 'High', desc: 'Must be a member for 10+ minutes' },
]

const contentFilterLevels = [
  { id: 'off', label: 'Off', desc: 'No content filtering' },
  { id: 'moderate', label: 'Moderate', desc: 'Scan messages from members without roles' },
  { id: 'strict', label: 'Strict', desc: 'Scan all messages' },
]

export function SafetySettings() {
  const [verification, setVerification] = useState('none')
  const [contentFilter, setContentFilter] = useState('off')

  return (
    <Container>
      <Header>
        <Title>Safety</Title>
      </Header>
      <ScrollView flex={1}>
        <Body>
          <View>
            <SectionTitle>Verification Level</SectionTitle>
            <SectionDesc>Set how strictly new members are verified before they can chat.</SectionDesc>
            <OptionRow>
              {verificationLevels.map((level) => (
                <RadioItem key={level.id} onPress={() => setVerification(level.id)}>
                  <RadioDot active={verification === level.id}>
                    {verification === level.id && <RadioFill />}
                  </RadioDot>
                  <View>
                    <RadioLabel>{level.label}</RadioLabel>
                    <Text fontFamily="$fontBody" fontSize={12} color="$sidebarMuted">{level.desc}</Text>
                  </View>
                </RadioItem>
              ))}
            </OptionRow>
          </View>

          <View>
            <SectionTitle>Content Filter</SectionTitle>
            <SectionDesc>Automatically scan and delete messages with explicit content.</SectionDesc>
            <OptionRow>
              {contentFilterLevels.map((level) => (
                <RadioItem key={level.id} onPress={() => setContentFilter(level.id)}>
                  <RadioDot active={contentFilter === level.id}>
                    {contentFilter === level.id && <RadioFill />}
                  </RadioDot>
                  <View>
                    <RadioLabel>{level.label}</RadioLabel>
                    <Text fontFamily="$fontBody" fontSize={12} color="$sidebarMuted">{level.desc}</Text>
                  </View>
                </RadioItem>
              ))}
            </OptionRow>
          </View>
        </Body>
      </ScrollView>
    </Container>
  )
}
